import React from "react";
import { Card, CardBody, Container, Row, Col, Button } from "reactstrap";
import { getStats } from "../../components/helpers/StatsHelpers";
import { RiCalendarLine } from "react-icons/ri";
import { SeoHelper } from "../../components/helpers/SeoHelper";
import InstructionsWizard from "./InstructionsWizard";

class CreateACuratedSongFlowFromALectionaryHelp extends React.Component {
  state = { songBookCount: null };

  constructor(props) {
    super(props);
    getStats.call(this);
  }

  stepsData = [
    {
      title: "Create a curated song-flow from a Lectionary",
      description:
        "At the end of this guide you will have:<br/><br/>" +
        "<img src=\"/help-images/blue-arrow.png\" style=\"width: 40px; height: auto;\">&nbsp;" +
        "created a song-flow using a lectionary reading as your starting point" +
        "<br/><br/><b>Please note:</b> using a lectionary to build a song-flow requires a paid account. " +
        "If you are not yet a member, <a href='/register/choose-your-plan'>register here</a>.",
    },
    {
      title: "From the home page",
      description:
        "The <a href='/lectionary/choose-lectionary'>Build from a Lectionary</a> feature is available from the <a href='/'>home page</a>. " +
        "Find the <b>Build from a Lectionary</b> option and click it. " +
        "If you are not signed in, you will see a prompt asking you to sign in or register before continuing.",
    },
    {
      title: "Choose your lectionary",
      description:
        "Select the lectionary that your church or denomination follows. The current options are:" +
        "<br/><br/>&bull; Methodist Lectionary" +
        "<br/>&bull; Revised Common Lectionary (RCL)" +
        "<br/>&bull; Church of England Lectionary" +
        "<br/><br/>Roman Catholic lectionary support is coming soon.",
    },
    {
      title: "Choose a reading",
      description:
        "Once you have selected your lectionary, you will be shown the upcoming readings organised by date and season. " +
        "Select the reading you would like to plan worship around and click <b>CONTINUE</b>.",
    },
    {
      title: "Select your song books",
      description:
        "You can now choose which song books to search across. By default all available song books are included. " +
        "Use the song book selector on the right-hand side to narrow or expand your selection, then click <b>CONTINUE</b>.",
    },
    {
      title: "Choose your songs",
      description:
        "You are presented with a list of songs that relate to the lectionary reading. Each song shows its title, author, song book, and where available, key, time signature, tempo, and CCLI number." +
        "<br/><br/>Click the selector toggle next to any song to add it to your song-flow. Click again to remove it. " +
        "When you are happy with your selection, click <b>CURATE SONG-FLOW</b> at the bottom of the page.",
    },
    {
      title: "Your curated song-flow",
      description:
        "Your song-flow is now ready. You can reorder songs by dragging them into position, save the song-flow, and share it with your team.",
    },
    {
      title: "What's next",
      description:
        "You have built a song-flow from a lectionary reading. Here are some things you can do next:" +
        "<br/><br/><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> <a href='/help/reordering-songs-in-your-song-flow'>Reorder songs in your song-flow</a>" +
        "<br/><br/><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> <a href='/help/saving-and-managing-your-song-flows'>Save and manage your song-flows</a>" +
        "<br/><br/><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> <a href='/help/sharing-a-song-flow'>Share your song-flow with your team</a>",
      image: "/help-images/well-done.png",
      enlargeable: false,
    },
  ];

  render() {
    return (
      <>
        <SeoHelper
          uri="/help/create-a-curated-song-flow-from-a-lectionary"
          title="Create a curated song-flow from a Lectionary | Help | The Worship Bible"
          description="Explains how to use a Lectionary to build a song-flow. Requires a paid account."
        />
        <div className="position-relative">
          <section className="section section-lg section-shaped pb-250">
            <div className="shape shape-style-1 shape-default">
              <span/><span/><span/><span/><span/><span/><span/><span/><span/>
            </div>
            <Container className="py-lg-md d-flex">
              <div className="col px-0">
                <Row>
                  <Col lg="8">
                    <h1 className="display-3 text-white">
                      Building your song-flows{" "}<span>help</span>
                    </h1>
                  </Col>
                </Row>
              </div>
            </Container>
            <div className="separator separator-bottom separator-skew">
              <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" version="1.1" viewBox="0 0 2560 100" x="0" y="0">
                <polygon className="fill-white" points="2560 0 2560 100 0 100"/>
              </svg>
            </div>
          </section>
        </div>
        <section className="section section-lg pt-lg-0 mt--200">
          <Container>
            <Row className="justify-content-center">
              <Col lg="12">
                <Row className="row-grid">
                  <Col lg="12">
                    <Card className="card-lift--hover shadow border-0">
                      <CardBody className="py-5">
                        <Row className="mt-3">
                          <Col>
                            <div className="d-flex align-items-center mb-3">
                              <RiCalendarLine color="#5e72e4" size="24" className="mr-2"/>
                              <h2 style={{fontSize: "1rem"}} className="text-primary mb-0">Create a curated song-flow from a Lectionary</h2>
                            </div>
                          </Col>
                          <Col md="3" xs="12">
                            <Button block type="button" className="mb-2" color="white" href="/help">
                              <span className="btn-inner--text">Back to help</span>
                            </Button>
                          </Col>
                        </Row>
                        <InstructionsWizard stepsData={this.stepsData}/>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
      </>
    );
  }
}

export default CreateACuratedSongFlowFromALectionaryHelp;
